import React from 'react';

import {
    formatInteger,
    formatOneDecimal,
    formatPercentage
} from '../../utils/numberUtils';
import { MAX_COMPARED_LPS } from './conversaoLPsData';

const formatRate = (value) => (value === null ? '—' : `${formatPercentage(value)}%`);

const formatGap = (gap) => {
    if (gap === null) return 'sem tráfego';
    if (gap === 0) return 'melhor conversão';

    return `${formatOneDecimal(gap)} p.p. abaixo da melhor`;
};

export const getSlotColor = (slot) => `var(--crm-lp-slot-${slot + 1})`;

const ConversaoLPsCompare = ({ focusedStats, notice, onRemove }) => {
    const bestRate = Math.max(...focusedStats.map((stat) => stat.conversao ?? -1));
    const maxRate = Math.max(bestRate, 0);

    return (
        <div className='crm-lp-compare'>
            <div className='crm-lp-chips' aria-label='Landing pages em comparação'>
                {focusedStats.map((stat) => (
                    <span className='crm-lp-chip' key={stat.id} style={{ '--lp-color': getSlotColor(stat.slot) }}>
                        <i aria-hidden='true' />
                        {stat.nome}
                        {focusedStats.length > 1 && (
                            <button type='button' aria-label={`Remover ${stat.nome} da comparação`} onClick={() => onRemove(stat.id)}>
                                ×
                            </button>
                        )}
                    </span>
                ))}
                {notice
                    ? <span className='crm-lp-notice'>{notice}</span>
                    : (
                        <span className='crm-lp-hint'>
                            {`Até ${MAX_COMPARED_LPS} LPs. Clique numa linha do ranking para adicionar ou remover.`}
                        </span>
                    )}
            </div>

            <div className='crm-lp-compare-cards' style={{ '--cards': Math.max(2, focusedStats.length) }}>
                {focusedStats.map((stat) => {
                    const gap = stat.conversao === null ? null : bestRate - stat.conversao;

                    return (
                        <div className='crm-lp-compare-card' key={stat.id} style={{ '--lp-color': getSlotColor(stat.slot) }}>
                            <div className='crm-lp-compare-card-heading'>
                                <i aria-hidden='true' />
                                <strong title={stat.url || stat.nome}>{stat.nome}</strong>
                            </div>
                            <div className='crm-lp-compare-card-rate'>
                                <strong>{formatRate(stat.conversao)}</strong>
                                <span>conversão</span>
                            </div>
                            <div className='crm-lp-compare-bar' aria-hidden='true'>
                                <i style={{ width: `${maxRate > 0 ? ((stat.conversao ?? 0) / maxRate) * 100 : 0}%` }} />
                            </div>
                            <p className={`crm-lp-compare-gap${gap === 0 ? ' is-best' : ''}`}>{formatGap(gap)}</p>
                            <dl>
                                <div>
                                    <dt>Visitas</dt>
                                    <dd>{formatInteger(stat.visitas)}</dd>
                                </div>
                                <div>
                                    <dt>Leads</dt>
                                    <dd>{formatInteger(stat.leads)}</dd>
                                </div>
                                <div>
                                    <dt>Fechados</dt>
                                    <dd>{formatInteger(stat.leads_fechados)}</dd>
                                </div>
                                <div>
                                    <dt>Fechamento</dt>
                                    <dd>{formatRate(stat.fechamento)}</dd>
                                </div>
                            </dl>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ConversaoLPsCompare;
